export const loadSamplersIntoTrack = async (track, trackData, subSequence) => {
    track.pattern.volume = trackData.volume;
    if ('samplers' in trackData) {
        for (var soundId in trackData.samplers) {
            await track.addSound(
                soundId, // the ipfs hash of the sound
                trackData.samplers[soundId], // the configuration data of the sampler
                undefined,
                false);
        }
    }
    
    if ('envelopes' in trackData) {
        for (let i in trackData.envelopes) {
            track.connectToEnvelope(subSequence.envelopes[trackData.envelopes[i]]);
        }
    }
    if ('envelopeConnections' in trackData) {
        for (let i in trackData.envelopeConnections) {
            let connection = trackData.envelopeConnections[i];
            track.connectToEnvelope(
                subSequence.envelopes[connection.envelope],
                connection.mode);
        }
    }
}
